module.exports = __webpack_public_path__ + "static/media/保腎1.3bd8e723.png";